<template>
  <v-container>
    <template>
      <div class="text-center">
        <v-dialog
          v-model="dialog"
          width="900"
          @click:outside="closeModal"
          :retain-focus="false"
        >
          <v-card class="custom-card" rounded="0">
            <v-toolbar color="secondary" class="white--text">
              <v-toolbar-title class="font-weight-bold">{{
                $t("farm.addNewUser")
              }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon class="white--text" @click="closeModal">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-form
              ref="addUser"
              v-model="valid"
              lazy-validation
              autocomplete="off"
            >
              <v-card-text class="black--text">
                <v-row>
                  <v-col lg="6" md="6" sm="6" xs="12">
                    <div class="form">
                      <label for="name"
                        >{{ $t("First Name")
                        }}<span style="color: red">*</span></label
                      >
                      <v-text-field
                        v-model="user.firstName"
                        :placeholder="$t('name')"
                        outlined
                        dense
                        :error-messages="errors.firstName"
                        :rules="rules.firstName"
                      ></v-text-field>
                    </div>
                  </v-col>
                  <v-col lg="6" md="6" sm="6" xs="12">
                    <div class="form">
                      <label for="name"
                        >{{ $t("Last Name")
                        }}<span style="color: red">*</span></label
                      >
                      <v-text-field
                        v-model="user.lastName"
                        :placeholder="$t('name')"
                        outlined
                        dense
                        :error-messages="errors.lastName"
                        :rules="rules.lastName"
                      ></v-text-field>
                    </div>
                  </v-col>
                  <v-col lg="6" md="6" sm="6" xs="12">
                    <div class="form">
                      <label for="email"
                        >{{ $t("Email Id")
                        }}<span style="color: red">*</span></label
                      >
                      <v-text-field
                        v-model="user.email"
                        :placeholder="$t('user.emailAddr')"
                        outlined
                        dense
                        :error-messages="errors.email"
                        :rules="rules.email"
                      ></v-text-field>
                    </div>
                  </v-col>
                  <v-col lg="6" md="6" sm="6" xs="12">
                    <div class="form">
                      <label for="mobile">{{ $t("Mobile Number") }}</label>
                      <v-text-field
                        v-model="user.mobile"
                        :placeholder="$t('user.enterYourPhoneNumber')"
                        outlined
                        dense
                        v-mask="[
                          '+',
                          /\d/,
                          /\d/,
                          ' ',
                          /\d/,
                          /\d/,
                          /\d/,
                          ' ',
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                          ' ',
                          /\d/,
                          /\d/,
                          /\d/,
                        ]"
                      ></v-text-field>
                    </div>
                  </v-col>
                  <!-- <v-col lg="6" md="6" sm="6" xs="12">
                    <div class="form">
                      <label for="password"
                        >{{ $t("password")
                        }}<span style="color: red">*</span></label
                      >
                      <v-text-field
                        :type="passwordType"
                        :append-icon="passwordIcon"
                        @click:append="changePasswordType"
                        v-model="user.password"
                        :placeholder="$t('user.enterPassword')"
                        outlined
                        dense
                        :error-messages="errors.password"
                        autocomplete="on"
                        :rules="rules.password"
                      ></v-text-field>
                    </div>
                  </v-col> -->
                  <v-col lg="6" md="6" sm="6" xs="12">
                    <div class="form">
                      <label for="role">Country</label>
                      <v-select
                        v-model="user.countryId"
                        :items="countries"
                        item-text="name"
                        item-value="id"
                        outlined
                        dense
                        placeholder="Select Country"
                        @change="getStateByCountryId"
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col lg="6" md="6" sm="6" xs="12">
                    <div class="form">
                      <label for="role">Province State</label>
                      <v-select
                        v-model="user.stateId"
                        :items="states"
                        item-text="name"
                        item-value="id"
                        outlined
                        dense
                        placeholder="Select State"
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col lg="6" md="6" sm="6" xs="12">
                    <div class="form">
                      <label for="role"
                        >{{ $t("role")
                        }}<span style="color: red">*</span></label
                      >
                      <v-select
                        v-model="user.role"
                        :items="rolesList"
                        item-text="name"
                        item-value="roleNumber"
                        outlined
                        dense
                        :loading="roleLoading"
                        :placeholder="$t('farm.selectRole')"
                      ></v-select>
                      <span class="errorf">{{ errors.role }}</span>
                    </div>
                  </v-col>
                  <v-col lg="6" md="6" sm="6" xs="12">
                    <div class="form">
                      <label for="role"
                        >{{ $t("Status")
                        }}<span style="color: red">*</span></label
                      >
                      <v-select
                        v-model="user.status"
                        :items="statusList"
                        outlined
                        dense
                        :error-messages="errors.status"
                        :loading="roleLoading"
                        :rules="rules.role"
                        :placeholder="$t('Select Status')"
                      ></v-select>
                      <span class="errorf">{{ errors.role }}</span>
                    </div>
                  </v-col>
                </v-row>

                <v-divider class="mt-5"></v-divider>
                <v-card-actions class="mt-10" style="padding-right: 0">
                  <v-spacer></v-spacer>
                  <v-btn
                    @click="closeModal"
                    outlined
                    class="mr-2"
                    right
                    height="44"
                    width="116"
                    depressed
                    color="primary"
                  >
                    {{ $t("cancel") }}
                  </v-btn>
                  <v-btn
                    @click="saveUser"
                    right
                    height="44"
                    width="116"
                    color="primary"
                  >
                    {{ $t("Submit") }}
                  </v-btn>
                </v-card-actions>
              </v-card-text>
            </v-form>
          </v-card>
        </v-dialog>
      </div>
    </template>
  </v-container>
</template>

<script>
/* eslint-disable */
import loadingMixin from "@/mixins/LoadingMixin";
import generalMixin from "@/mixins/GeneralMixin";
import PermissionsMixin from "@/mixins/PermissionsMixin";
import { createUser, country, getStateByCountry } from "@/graphql/Users.gql";

import UserService from "@/_services/UserService";

export default {
  apollo: {
    countries: {
      query: country,
      update: (data) => console.log(data),
      fetchPolicy: "no-cache",
      variables() {},
      result({ data }) {
        console.log(data);
        this.countries = data.country;
      },
    },
  },
  created() {
    const fetchData = async () => {
      this.startLoading();
      this.departmentList = await this.getDepartments();
      this.stopLoading();
    };
    fetchData();
  },
  computed: {
    dialog() {
      return this.dialogI;
    },
  },
  data() {
    return {
      countries: [],
      states: [],
      passwordType: "password",
      passwordIcon: "mdi-eye-off",
      valid: true,
      departmentList: [],
      rolesList: [
        { name: "Admin", roleNumber: "admin" },
        { name: "Farmer", roleNumber: "farmer" },
      ],
      statusList: ["Active", "Inactive"],
      roleLoading: false,
      fieldType: { text: "text" },
      error: false,
      errors: {
        firstName: "",
        lastName: "",
        email: "",
        mobile: "",
        password: "",
        department: "",
        role: "",
      },
      user: {
        firstName: "",
        lastName: "",
        email: "",
        mobile: "",
        password: "",
        role: "farmer",
        status: "active",
        countryId: null,
        stateId: null,
      },
      rules: {
        firstName: [
          (v) => !!v || this.$t("First Name is Required"),
          (v) => this.onlyAlpha(v) || this.$t("nameCanContainOnlyAlphabets"),
          (v) => (v && v.length <= 15) || this.$t("nameMustBeLessThan15Chars"),
        ],
        lastName: [
          (v) => !!v || this.$t("Last Name is Required"),
          (v) => this.onlyAlpha(v) || this.$t("nameCanContainOnlyAlphabets"),
          (v) => (v && v.length <= 15) || this.$t("nameMustBeLessThan15Chars"),
        ],
        email: [
          (v) => !!v || this.$t("emailRequired"),
          (v) => this.validateEmail(v) || this.$t("invalidEmailFormat"),
        ],
        mobile: [
          (v) => !!v || this.$t("mobNumReq"),
          // v => this.validMobileNumber(v) || this.$t('invalidMobFormat')
        ],
        password: [(v) => !!v || this.$t("passwordRequired")],
        department: [(v) => !!v || this.$t("departmentReq")],
      },
    };
  },
  methods: {
    getStateByCountryId() {
      this.$apollo
        .query({
          query: getStateByCountry,
          variables: {
            stateListInput: {
              countryId: +this.user.countryId,
            },
          },
        })
        .then((data) => {
          if (data?.data?.getStateByCountry?.length) {
            this.states = data.data.getStateByCountry;
          }
        })
        .catch((e) => Promise.reject(e));
    },
    changePasswordType() {
      if (this.passwordType == "password") {
        this.passwordType = "text";
        this.passwordIcon = "mdi-eye";
      } else {
        this.passwordType = "password";
        this.passwordIcon = "mdi-eye-off";
      }
    },
    closeModal() {
      this.$emit("closeAddUser");
    },
    async saveUser() {
      try {
        if (!this.$refs.addUser.validate()) return;
        this.startLoading();
        this.user.mobile = this.user.mobile.replace(/ /g, "");
        this.user.mobile = this.user.mobile.replace("+", "");

        let res = await this.$apollo.mutate({
          mutation: createUser,
          variables: {
            createUserInput: this.user,
          },
        });

        this.$emit("userAdded", {
          success: true,
          message: res.message,
          userObj: res,
        });
      } catch (error) {
        this.$emit("userAdded", { success: false, message: error });
        this.stopLoading();
      }
      this.closeModal();
      this.stopLoading();

      // UserService.addUser(this.user)
      // .then( data => {
      //     if(data.success){
      //         this.$emit('userAdded', { success:true, message: data.message});
      //     }else{

      //     }
      //     this.closeModal();
      //     this.stopLoading()
      // })
      // .catch( err => {
      //     this.stopLoading()
      //     if(err.response.data.message.errors.length > 0){
      //         err.response.data.message.errors.forEach(e => {
      //             this.errors[e.param] = e.msg;
      //         });
      //     }
      // });
    },

    emptyErrors() {
      this.error = false;

      this.errors.email = "";
      this.errors.mobile = "";
      this.errors.password = "";

      this.errors.role = "";
    },
  },
  props: {
    dialogI: {
      type: Boolean,
      required: true,
    },
  },
  mixins: [loadingMixin, generalMixin, PermissionsMixin],
};
</script>

<style>
.v-dialog::-webkit-scrollbar {
  width: 0px;
}
.v-dialog::-webkit-scrollbar-thumb {
  background-color: darkgrey;
  outline: 1px solid slategrey;
}
.v-dialog::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
.custom-card {
  background: #ffffff !important;
  box-shadow: 0px 30px 30px rgb(106 119 132 / 41%) !important;
  border-radius: 23px !important;
}
.custom-card .v-card__text {
  width: 100%;
  padding: 37px 60px !important;
}
.card-heading-1 {
  margin-bottom: 28px;
}
.custom-card .v-card__text .card-heading-1 h2 {
  font-size: 30px;
  font-weight: 700;
}

.form label {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  font-size: 15px;
  font-family: Poppins-Medium;
}

.form span {
  color: red;
}
</style>
